import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class NavbarStateService {
  /**
   * Signal to track whether navbar interactions should be disabled
   */
  readonly isDisabled = signal<boolean>(false);
}
